import PropTypes from "prop-types";
import {
  Button,
  Form,
  Input,
  Select,
  Switch,
  App
} from 'antd';
import "antd/dist/reset.css";
import { ContentApi } from "../../../../shared/api/contentApi";
import DialogEditStrings, { DialogEditStringsRow } from "../../_shared/DialogEditStrings";

function parseJsonOrNull(value) {
    const trimmed = String(value || "").trim();
    if (!trimmed) return null;
    try {
        return JSON.parse(trimmed);
    } catch (error) {
        throw new Error("Некорректный JSON");
    }
}

export default function ParameterEditDialog({ open, parameter, projectId, versionId, onClose, onSaved }) {
    return (
        <DialogEditStrings
            open={open}
            entity={parameter}
            projectId={projectId}
            versionId={versionId}
            onClose={onClose}
            onSaved={onSaved}
            title="Редактировать параметр"
            renameSystemName={ContentApi.renameParameterSystemName}
            patchEntity={ContentApi.patchParameter}
            getEntityId={(entity) => entity?.id || entity?.parameterId}
            saveErrorMessage="Не удалось сохранить параметр"
            dialogSize="lg"
            getInitialExtraState={(entity) => ({
                defaultValueText: entity?.defaultValue == null ? "" : JSON.stringify(entity.defaultValue),
                optionsText: entity?.options == null ? "" : JSON.stringify(entity.options, null, 2),
            })}
            buildPayload={({ name, description, extraState }) => ({
                name: name.trim(),
                description: description.trim() || null,
                defaultValue: parseJsonOrNull(extraState.defaultValueText),
                options: parseJsonOrNull(extraState.optionsText),
            })}
            renderExtraFields={({ extraState, setExtraField }) => (
                <App>
                    <Form.Item label="Default Value (JSON)">
                        <Input.TextArea
                            className="input w-full"
                            rows={2}
                            value={extraState.defaultValueText || ""}
                            onChange={(e) => setExtraField("defaultValueText", e.target.value)}
                        />
                    </Form.Item>

                    <Form.Item label="Options (JSON)">
                        <Input.TextArea
                            className="input w-full"
                            rows={4}
                            value={extraState.optionsText || ""}
                            onChange={(e) => setExtraField("optionsText", e.target.value)}
                        />
                    </Form.Item>
                </App>
            )}
        />
    );
}

ParameterEditDialog.propTypes = {
    open: PropTypes.bool,
    parameter: PropTypes.object,
    projectId: PropTypes.string,
    versionId: PropTypes.string,
    onClose: PropTypes.func,
    onSaved: PropTypes.func,
};
